import React from 'react';
import { useFamilyContext } from '../../contexts/FamilyContext';
import ManagePageHeader from './ManagePageHeader';
import ParentManageView from './ParentManageView';
import KidManageView from './KidManageView';
import '../../styles/design-system.css';
import '../../styles/manage-page.css';

export default function ManagePage() {
  const { currentUser, loading } = useFamilyContext();

  if (loading) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <div className="text-stone-500">Loading...</div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <div className="text-stone-500">Please sign in to continue</div>
      </div>
    );
  }

  const isParent = currentUser?.isParent;

  return (
    <div className="min-h-screen bg-stone-50">
      <ManagePageHeader />
      
      <main className="manage-content">
        {isParent ? <ParentManageView /> : <KidManageView />}
      </main>
    </div>
  );
}